// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-title app-title {
  --line-size: 25px;
}
.toolbar-title .subtitle {
  margin: 0;
  color: #9aabc3;
  font-weight: var(--font-body-small-weight);
  font-size: var(--font-body-small-size);
  line-height: var(--font-body-small-line-height);
}

ion-content {
  --background: var(--ion-color-background);
  --padding-top: 30px;
  --padding-bottom: 30px;
  --padding-start: 20px;
  --padding-end: 20px;
}
ion-content > p {
  margin: 0;
  padding: 0 0 15px;
}
ion-content > p:last-child {
  padding: 15px 0 0;
  border-top: 1.5px solid #B6B6B6;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/privacity-modal/privacity-modal.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAGI;EACI,SAAA;EACA,cAAA;EACA,0CAAA;EACA,sCAAA;EACA,+CAAA;AADR;;AAKA;EACI,yCAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AAFJ;AAII;EACI,SAAA;EACA,iBAAA;AAFR;AAIQ;EACI,iBAAA;EACA,+BAAA;AAFZ","sourcesContent":[".toolbar-title {\r\n    app-title {\r\n        --line-size: 25px;\r\n    }\r\n\r\n    .subtitle {\r\n        margin: 0;\r\n        color: #9aabc3;\r\n        font-weight: var(--font-body-small-weight);\r\n        font-size: var(--font-body-small-size);\r\n        line-height: var(--font-body-small-line-height);\r\n    }\r\n}\r\n\r\nion-content {\r\n    --background: var(--ion-color-background);\r\n    --padding-top: 30px;\r\n    --padding-bottom: 30px;\r\n    --padding-start: 20px;\r\n    --padding-end: 20px;\r\n\r\n    > p {\r\n        margin: 0;\r\n        padding: 0 0 15px;\r\n\r\n        &:last-child {\r\n            padding: 15px 0 0;\r\n            border-top: 1.5px solid #B6B6B6;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
